import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
} from 'beyond-util';
import { ReportHeaderModule } from '../../../components/report-header/report-header.module';
import { RealizacijaUgovoraComponent } from './realizacija-ugovora.component';
import { ChartsModule } from 'ng2-charts-x';
import { DecimalPipe } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [RealizacijaUgovoraComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    ReportHeaderModule,
    ChartsModule,
    NgxSpinnerModule,
  ],
  exports: [RealizacijaUgovoraComponent],
  entryComponents: [RealizacijaUgovoraComponent],
  providers: [DecimalPipe],
})
export class RealizacijaUgovoraModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/realizacija-ugovora/realizacija-ugovora.module.ts